import React from 'react';

import { useAppContext } from 'src/components/app-context';
import { usePriceRowContext } from '../../../price-row-context';

import { IconDropdownDown } from '@prisjakt/ui/icon/dropdown-down';
import { IconDropdownUp } from '@prisjakt/ui/icon/dropdown-up';
import { IconMenuKebab } from '@prisjakt/ui/icon/menu-kebab';

import { ViewSize } from '../../types';
import { StyledExpandButton } from './styles';

interface IExpandButton {
  expanded?: boolean;
  onClick?: () => void;
  title?: string;
}

export const ExpandButton: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IExpandButton>>
> = ({ expanded = false, onClick }) => {
  const { t } = useAppContext();
  const { viewSize } = usePriceRowContext();
  const title = t('product', 'price.more-info');

  return (
    <StyledExpandButton
      type="button"
      aria-label={title}
      onClick={onClick}
      title={title}
      data-test="ExpandButton"
    >
      {viewSize === ViewSize.SMALL && (
        <IconMenuKebab color="base900" size={20} />
      )}

      {viewSize >= ViewSize.MEDIUM && expanded && (
        <IconDropdownUp color="base900" size={20} />
      )}

      {viewSize >= ViewSize.MEDIUM && !expanded && (
        <IconDropdownDown color="base900" size={20} />
      )}
    </StyledExpandButton>
  );
};
